import { money } from "@/lib/format";
import { Star, Gift } from "lucide-react";

export default function LoyaltyCard({ loyalty }) {
  if (!loyalty) return null;
  const tierLabel = loyalty.tier === "premium" ? "Premium" : loyalty.tier === "basic" ? "Basic" : "Member";
  const stampsNeeded = loyalty.stamps_per_reward || 0;
  return (
    <div className="rounded-2xl bg-primary p-5 text-primary-foreground" data-testid="loyalty-card">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs opacity-80">Loyalty · {tierLabel}</p>
          <p className="font-display text-2xl font-bold">{loyalty.points} pts</p>
        </div>
        <div className="text-right text-xs opacity-90">
          <p>{loyalty.completed_orders} completed</p>
          {loyalty.rewards_available > 0 ? (
            <p className="mt-1 inline-flex items-center gap-1 rounded-full bg-primary-foreground/20 px-2 py-0.5"><Gift className="h-3 w-3" /> {loyalty.rewards_available} reward{loyalty.rewards_available > 1 ? "s" : ""}</p>
          ) : null}
        </div>
      </div>
      {stampsNeeded > 0 ? (
        <div className="mt-4 flex items-center gap-1.5">
          {Array.from({ length: stampsNeeded }).map((_, i) => (
            <Star key={i} className={`h-4 w-4 ${i < (loyalty.stamps % stampsNeeded || (loyalty.stamps > 0 && loyalty.stamps % stampsNeeded === 0 ? stampsNeeded : 0)) ? "fill-current" : "opacity-30"}`} />
          ))}
          <span className="ml-1 text-xs opacity-80">{loyalty.stamps}/{stampsNeeded} stamps</span>
        </div>
      ) : null}
      {loyalty.welcome_offer_active ? (
        <p className="mt-3 rounded-lg bg-primary-foreground/15 px-3 py-2 text-xs">Welcome offer active: {loyalty.welcome_offer_percent}% off your next order (up to {money(loyalty.punch_card_max_value || 100)}).</p>
      ) : null}
    </div>
  );
}
